import React from "react";
import LazyLoad from "react-lazyload";

class Thumbnail extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      source: props.src,
      link: props.link || false,
      remainder: props.remainder || false
    };
  }

  render () {
    const remainder = this.state.remainder;
    const styles = {
      backgroundImage: `url('${this.state.source}')`
    };

    return (
      <LazyLoad height={110} offset={100} once>
        <div className="afd-thumbnail">
          <div className="afd-thumbnail__image" style={styles} />
          {remainder &&
            (<div className="afd-thumbnail__overlay">+{remainder}</div>)}
          {this.state.link &&
            (<a href={this.state.link} target="_blank" className="afd-thumbnail__link" rel="noreferrer" />)}
        </div>
      </LazyLoad>
    );
  }
}

export default Thumbnail;
